import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sympheny-user-guide-info',
  templateUrl: './user-guide-info.component.html',
  styleUrls: ['./user-guide-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class UserGuideInfoComponent {}
